import React, { useState, useEffect } from "react";
import { LayoutHome } from "./LayoutHome";
import { Carousel } from "antd";
import { Text } from "rsuite";

export const Home = () => {
  const [nombre, setNombre] = useState(
    JSON.parse(localStorage.getItem("auth")).nombre,
  );

  const contentStyle = {
    margin: 0,
    height: "160px",
    color: "#fff",
    lineHeight: "160px",
    textAlign: "center",
    background: "#364d79",
  };

  const [greeting, setGreeting] = useState("");

  useEffect(() => {
    const updateGreeting = () => {
      const currentHour = new Date().getHours();
      let newGreeting = "";

      if (currentHour >= 5 && currentHour < 12) {
        newGreeting = `Bienvenid@, ${nombre}, buenos días!`;
      } else if (currentHour >= 12 && currentHour < 19) {
        newGreeting = `Bienvenid@ ${nombre}, buenas tardes!`;
      } else {
        newGreeting = `Bienvenid@ ${nombre}, buenas noches!`;
      }
      setGreeting(newGreeting);
    };

    // Update greeting initially and then every minute
    updateGreeting();
    const intervalId = setInterval(updateGreeting, 60000); // Update every minute

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <LayoutHome title={"Home"}>
      <Text size="2xl">{greeting}</Text>
      <Carousel autoplay={{ dotDuration: true }} autoplaySpeed={5000}>
        <div>
          <h3 style={contentStyle}>1</h3>
        </div>
        <div>
          <h3 style={contentStyle}>2</h3>
        </div>
        <div>
          <h3 style={contentStyle}>3</h3>
        </div>
        <div>
          <h3 style={contentStyle}>4</h3>
        </div>
      </Carousel>
    </LayoutHome>
  );
};
